module.exports = __webpack_public_path__ + "static/media/cg.fcbd5c7b.svg";